var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-chip",
    {
      staticClass: "chip-status pl-0 pr-3",
      class: [_vm.colorClass, _vm.large ? "large" : ""]
    },
    [
      _c("v-icon", { attrs: { size: _vm.large ? 16 : 27 } }, [
        _vm._v(
          " " + _vm._s(_vm.large ? "mdi-circle" : "mdi-circle-medium") + " "
        )
      ]),
      _c(
        "span",
        { staticClass: "chip-status-content ml-n1" },
        [
          !_vm.custom
            ? _c("span", [_vm._v(_vm._s(_vm.getStatusText()))])
            : _vm._e(),
          _vm.custom ? _vm._t("default") : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }